// Кутийките на „По сервитьори".
//
// Само две — оборотът и колко се пада на човек. Разбивката по методи на
// плащане НЕ е тук: всички методи стоят в лентата „По методи на плащане" под
// кутийките, както в „Продажби по периоди" (кутийка на метод би скрила
// опашката в „Други методи").

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { ReportKpiCard } from "../ReportKpiCard";
import { deltaPercent } from "../reportDelta";
import { pluralLabel } from "../reportPlural";
import type { WaitersSummary } from "./waitersMath";

type Props = {
  summary: WaitersSummary;
  previous: WaitersSummary | null;
};

export const WaitersKpis = ({ summary, previous }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-2.5">
      <ReportKpiCard
        kicker={t("reportsPage.waitersRevenue")}
        value={fmtEuro(summary.total)}
        sub={pluralLabel(
          t,
          summary.bills,
          "reportsPage.waitersBillsOne",
          "reportsPage.waitersBillsMany",
        )}
        delta={previous ? deltaPercent(summary.total, previous.total) : undefined}
        hero
      />

      <ReportKpiCard
        kicker={t("reportsPage.waitersRevenueAvgLabel")}
        value={fmtEuro(summary.averagePerWaiter)}
        sub={t("reportsPage.waitersOnShift", { count: summary.waiters })}
      />
    </div>
  );
};
